import React from 'react';
import { TbListDetails } from "react-icons/tb";
import './Home.css';
import { FaPlus } from 'react-icons/fa';
import { MdOutlineCall, MdOutlineMailOutline } from 'react-icons/md';
import { HomeLogic } from './HomeLogic';
import AddReferralModal from '../AddReferralModal/AddReferralModal';

function Home() {

  const {
    showModal,
    users,
    selectedUser,
    filteredData,
    handleOpenReferral,
    handleCloseReferral,
    handleReferralSubmit,
    handleSaveUser,
    handleViewDetails,
    handleUserChange,
  } = HomeLogic();

  const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
  return (
    <div className='main-content'>
      <div className="p-3 mb-0 mt-1 custom-bg-white rounded">
        <div className="d-flex justify-content-between align-items-center">
          <span className="m-0 title">Referrals</span>
          <div className="user-select-row">

            {/* <label>Select Users</label> */}
            {(accessLevel === 2 || accessLevel === 3) && (
              <select className="form-select" value={selectedUser} onChange={handleUserChange}>
                <option value="">All</option>
                {users.map(user => (
                  <option key={user.username} value={user.username}>
                    {user.name}
                  </option>
                ))}
              </select>
            )}

            <button onClick={handleOpenReferral} className='add-referreal-btn'>
              <FaPlus /> Add Referral
            </button>
          </div>
        </div>
      </div>

      <div className="grid-container">
        {filteredData.length === 0 ? (
          <div className="no-data-message">No referrals.</div>
        ) : (filteredData.map((client, index) => (
          <div key={index} className="card card-div" onClick={() => handleViewDetails(client)}>
            <div className="card-header">
              {client.firstName} {client.middleName} {client.lastName}
            </div>
            <div className="card-body-view">
              <p><MdOutlineMailOutline size={18} /> {client.email || "N/A"}</p>
              <p><MdOutlineCall size={18} className='home-call' /> {client.phoneNumber || "N/A"}</p>
              <span style={{
                color:
                  client.status === 'Install Complete' ? '#28a745' :
                    client.status === 'Install Scheduled' ? '#fd7e14' :
                      client.status === 'Sale Not Made' ? '#dc3545' :
                        client.status === 'Pending' ? '#007bff' :
                          client.status === 'Customer Requested More Time' ? '#f0ad4e' :
                            client.status === 'Unable to reach client' ? '#f1948a' :
                              'inherit',
                fontSize: "14px"
              }}>
                {client.status}
              </span>

              <div className="hover-view">
                <div
                  className="clickable-view"

                >
                  <span className="view-text">Details</span>
                  <TbListDetails className="view-icon" />
                </div>
              </div>
            </div>
          </div>
        ))
        )}
      </div>
      {showModal && (
        <AddReferralModal onClose={handleCloseReferral} onSave={handleSaveUser} onSubmit={handleReferralSubmit} />
      )}
    </div>
  );
}

export default Home;